import { Controller } from "stimulus"
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("[data-disable-with][disabled]").forEach(e => {
      e.disabled = false
    })
  }
}
